<p-paginator styleClass="my-5"
             (onPageChange)="onPageChange($event)"
             [first]="0"

             [rows]="paginationDetails?.totalElements / paginationDetails?.totalPages"
             [alwaysShow]="false"
             [totalRecords]="paginationDetails?.totalElements">
</p-paginator>
